import { render, staticRenderFns } from "./materialType.vue?vue&type=template&id=1e27c4e6&scoped=true&"
import script from "./materialType.vue?vue&type=script&lang=js&"
export * from "./materialType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e27c4e6",
  null
  
)

export default component.exports